import React from 'react';
import PropTypes from 'prop-types';
import ConnectedThird from './ConnectedThird';

// TODO: Move to react-viewerbase
const ThirdRouting = ({ match }) => <ConnectedThird />;

ThirdRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default ThirdRouting;
